function includeCSS() : void {
  const url = [biobarHost(), '/static/css/biobar.css'].join('');

  if (usingInternetExplorer()) {
    // eslint-disable-next-line
    // @ts-ignore
    document.createStyleSheet(url);
    return;
  }

  const styleTag = `<link href='${url}' rel='stylesheet' type='text/css'>`;
  document.head.insertAdjacentHTML('beforeend', styleTag);
}

// eslint-disable-next-line
//@ts-ignore
const usingInternetExplorer = () : boolean => document.createStyleSheet;

function biobarHost() : string {
  const url = getScriptUrl('biobar.js');
  return url.substring(0, url.lastIndexOf('static/'));
}

function getScriptUrl(fileName : string) : string {
  const scripts = document.getElementsByTagName('script');

  // eslint-disable-next-line
  return Array.prototype.slice.call(scripts).filter((x : any) => x.src.match(fileName))[0].src;
}

export default includeCSS;